/** 协议文档外链；未配置 REACT_APP_LEGAL_WEB_ORIGIN 时使用相对路径 */
export function h5LegalUrl(slug: string): string {
  const base = process.env.REACT_APP_LEGAL_WEB_ORIGIN?.trim();
  if (base) {
    return `${base.replace(/\/$/, "")}/legal/${slug}`;
  }
  return `/legal/${slug}`;
}
